import * as path from 'node:path';
import { cliSimpleGit } from '../../cli-simple-git.js';
import { yieldToEventLoop } from '../../git-runtime.js';
import { normalizeRepoPathRelativeToWorkspaceRoot } from './normalize-repo-path-relative-to-workspace-root.js';

/** Repo path relative to the bridge or session/preview workspace root for a git checkout directory. */
export async function resolveRepoPathRelativeToWorkspaceRoot(options: {
  checkoutPath: string;
  bridgeRoot: string;
  /** When the scope uses isolated worktrees: the session or preview parent path. */
  sessionParentPath: string | null;
}): Promise<string | null> {
  const checkoutPath = path.resolve(options.checkoutPath);
  const git = cliSimpleGit(checkoutPath);
  const sessionParentPath = options.sessionParentPath ? path.resolve(options.sessionParentPath) : null;

  let repoPathRelativeToWorkspaceRoot: string;
  if (sessionParentPath) {
    const checkoutPathRelativeToSessionParent = path.relative(sessionParentPath, checkoutPath);
    repoPathRelativeToWorkspaceRoot =
      checkoutPathRelativeToSessionParent === ''
        ? '.'
        : checkoutPathRelativeToSessionParent.replace(/\\/g, '/');
  } else {
    let gitTopLevel = checkoutPath;
    try {
      await yieldToEventLoop();
      gitTopLevel = (await git.raw(['rev-parse', '--show-toplevel'])).trim();
    } catch {
      gitTopLevel = checkoutPath;
    }
    const gitTopLevelRelativeToBridgeRoot =
      path.relative(options.bridgeRoot, path.resolve(gitTopLevel)).replace(/\\/g, '/') || '.';
    repoPathRelativeToWorkspaceRoot = gitTopLevelRelativeToBridgeRoot.startsWith('..')
      ? path.basename(path.resolve(gitTopLevel))
      : gitTopLevelRelativeToBridgeRoot;
  }

  return normalizeRepoPathRelativeToWorkspaceRoot(
    repoPathRelativeToWorkspaceRoot === '' ? '.' : repoPathRelativeToWorkspaceRoot,
  );
}
